import { render, staticRenderFns } from "./iconCheck.vue?vue&type=template&id=12dbabff&scoped=true"
import script from "./iconCheck.vue?vue&type=script&lang=js"
export * from "./iconCheck.vue?vue&type=script&lang=js"
import style0 from "./iconCheck.vue?vue&type=style&index=0&id=12dbabff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbabff",
  null
  
)

export default component.exports